import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { patientServices } from "../../../services/patientServices";

// Status constants
const STATUSES = Object.freeze({
  IDLE: "idle",
  LOADING: "loading",
  ERROR: "error",
});

// Initial state
const initialState = {
  patientName: "",
  patient_id: "",
  mobileData: {},
  patientMobile: "",
  status: STATUSES.IDLE,
};

// Thunks
export const fetchMobileSearch = createAsyncThunk(
  "mobileSearch/fetch",
  async (payload) => {
    return await patientServices.patientMobileSearch(payload);
  }
);

export const userSearch = createAsyncThunk(
  "searchUser/fetch",
  async (payload) => {
    return await patientServices.searchUser(payload);
  }
);

// Slice
export const mobileSlice = createSlice({
  name: "mobileSearch",
  initialState,
  reducers: {
    setPatientMobile: (state, action) => {
      state.patientMobile = action.payload;
    },
    setMobileData: (state, action) => {
      state.mobileData = action.payload;
    },
    setPatientName: (state, action) => {
      state.patientName = action.payload;
    },
    setPatient_id: (state, action) => {
      state.patient_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMobileSearch.pending, (state) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(fetchMobileSearch.fulfilled, (state, action) => {
        const patient = action.payload[0] || {};
        state.mobileData = action.payload;
        state.patientName = patient.name || "";
        state.patient_id = patient.id || "";
        state.patientMobile = patient.mobile || "";
        state.status = STATUSES.IDLE;
      })
      .addCase(fetchMobileSearch.rejected, (state) => {
        state.status = STATUSES.ERROR;
      })
      .addCase(userSearch.pending, (state) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(userSearch.fulfilled, (state, action) => {
        const patient = action.payload[0] || {};
        state.mobileData = action.payload;
        state.patientName = patient.name || "";
        state.patient_id = patient.id || "";
        state.patientMobile = patient.mobile || "";
        state.status = STATUSES.IDLE;
      })
      .addCase(userSearch.rejected, (state) => {
        state.status = STATUSES.ERROR;
      });
  },
});

// Export actions
export const {
  setPatientMobile,
  setMobileData,
  setPatientName,
  setPatient_id,
} = mobileSlice.actions;

// Export reducer
export default mobileSlice.reducer;
